module.exports = __webpack_public_path__ + "static/media/Calendar2.145aa144.svg";